import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Accounts/Login/Login';
import ForgotPassword from './Accounts/ForgotPassword/ForgotPassword';
import ResetPassword from './Accounts/ResetPassword/ResetPassword';
import Panel from './Panel/Panel';
import { setUserData } from './redux/Actions/UserAction';
import { getElevateUser } from './storage/Storage';
import { client } from './apollo/client';
import { seatGraphql } from './constant/Constant';
import QrGenration from './WebView/QrGenration/QrGenration';
import MyInput from './components/MyComponent/MyInput';
import toast, { Toaster } from 'react-hot-toast';

function App() {
  const dispatch = useDispatch();
  const UserReducer = useSelector(state => state.UserReducer);
  const pathName = window.location.pathname;
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkUserData = () => {
      try {
        const doc = getElevateUser();
        console.log("Fetched user from storage:", doc);
        if (doc) {
          dispatch(setUserData(doc));
        } else {
          console.log("No user data found in storage");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Optionally dispatch an error action or show notification
      } finally {
        setIsCheckingAuth(false);
      }
    };
    checkUserData();
  }, [dispatch]);

  // Component to render inside ApolloProvider
  const AppContent = () => {
    // Show loading state while checking authentication
    if (isCheckingAuth) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen ">
        <Routes>
          {/* Public routes - accessible without authentication */}
          <Route path="/login" element={UserReducer.user ? <Navigate to="/" /> : <Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password/:id" element={<ForgotPassword />} />
          <Route path="/reset-password" element={UserReducer.user ? <Navigate to="/" /> : <ResetPassword />} />
          <Route path="/reset-password/:token" element={UserReducer.user ? <Navigate to="/" /> : <ResetPassword />} />

          {/* Protected routes - require authentication */}
          <Route
            path="/product-qrcode/*"
            element={UserReducer.user ? <QrGenration /> : <Navigate to="/login" />}
          />
          <Route
            path="/*"
            element={UserReducer.user ? <Panel /> : <Navigate to="/login" />}
          />
        </Routes>
      </div>
    );
  };

  return (
    <ApolloProvider client={client}>
      <AppContent />
      <Toaster />
    </ApolloProvider>
  );
}

export default App;